import { cn } from "@/lib";
import { HTMLAttributes } from "react";

type ContainerHeaderProps = HTMLAttributes<HTMLElement>;

/**
 * The toolbar row under a page header: search and filters on the left, view
 * switches on the right. It sits on the ground, not in a card.
 */
export function ContainerHeader({ className, ...rest }: ContainerHeaderProps) {
  return (
    <div
      className={cn(
        "flex flex-col gap-3 md:flex-row md:items-center md:justify-between",
        className
      )}
      {...rest}
    />
  );
}
